<template>
    <div class="mt4 content">
        <div class="columns pt-6">
            <div class="column is-9-fullhd">
                <p class="has-text-white" v-if="conferences === null"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading conferences...</p>
                <div v-else>
                    <empty-state v-if="conferences.length === 0" icon="fa-info-circle" title="No conferences are open right now." text="Check back soon, or use an access code from your organizer under Conference Records."/>

                    <section class="pb-4" v-if="featuredConferences.length > 0">
                        <section-header title="Upcoming & Recent Conferences" icon="fa-calendar-alt" :count="featuredConferences.length"/>
                        <conference :conference="c" v-for="c in featuredConferences" :key="'featured-' + c.id" class="mb-5"/>
                    </section>

                    <section class="pb-6" v-if="conferences.length">
                        <section-header class="mt-6" title="All Conferences" icon="fa-presentation" :count="conferences.length"/>

                        <b-tabs class="conference-tabs" :animated="false">
                            <template v-for="tab in years">
                                <b-tab-item :key="'year-' + tab">
                                    <template #header><i class="fad fa-calendar mr-3"></i>{{ tab }}</template>

                                    <empty-state v-if="getByYear(tab).length === 0" icon="fa-info-circle" :text="'No conferences in ' + tab + '.'"/>
                                    <conference :conference="c" v-for="c in getByYear(tab)" :key="'year-' + tab + '-' + c.id" class="mb-5"/>
                                </b-tab-item>
                            </template>
                        </b-tabs>
                    </section>
                </div>
            </div>
            <div class="column has-text-white has-text-right is-3-fullhd is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only">
                <div class="mb-6">
                    <router-link :to="{name: 'registrations'}">
                        <b-button type="is-light" outlined><i class="fad fa-screen-users mr-3"></i>Your Conference Records</b-button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Conference from "../../components/Conference";
    import SectionHeader from "../../components/framework/SectionHeader";
    import EmptyState from "../../components/framework/EmptyState";
    import {client as http} from "../../http_client";
    import moment from "moment";

    export default {
        components: {Conference, SectionHeader, EmptyState},
        data: function() {
            return {
                conferences: null,
                years: Array.from({length: 6}, (v, k) => new Date().getFullYear() - k)
            };
        },
        computed: {
            // Starting within 30 days, started within the last 14, or pinned
            featuredConferences: function() {
                if (!this.conferences) return [];
                return this.conferences.filter(c => {
                    let start = moment(c.start_at);
                    return start.isBetween(moment(), moment().clone().add(30, 'days')) ||
                        start.isBetween(moment().clone().subtract(14, 'days'), moment()) || c.is_highlighted;
                });
            }
        },
        methods: {
            getByYear(year) {
                if (!this.conferences) return [];
                return this.conferences.filter(c => new Date(c.start_at).getFullYear() === year);
            }
        },
        mounted() {
            http.get('app/conferences/', {force: true}).then(response => {
                this.conferences = response.data;
            }).catch(err => {
                console.error('Conference list failed', err);
                this.conferences = [];
            });
        }
    };
</script>

<style lang="scss">
    .conference-tabs {

        .tabs {
            color: white;
            margin-bottom: 50px;

            ul {
                margin: 0;
                padding: 0;
            }

            li a {
                color: #9faec2 !important;
                font-size: 0.9rem;

                &:hover {
                    border-bottom-color: #6f8295;
                }
            }

            li.is-active a {
                color: #ffffff !important;
                border-bottom-color: #6f8295;
                font-size: 0.9rem;

            }
        }

        .tab-content {
            padding: 1rem 0 0 !important;
        }
    }

</style>
